import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ShowPasswordButtonComponent } from './show-password-button.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [
		ShowPasswordButtonComponent
	],
	imports: [
		CommonModule,
		MatIconModule,
		MatTooltipModule,
		TranslateModule
	],
	exports: [
		ShowPasswordButtonComponent
	]
})
export class ShowPasswordButtonModule {}
